// extracted by mini-css-extract-plugin
export default {"row":"BaseParametersStyles_row__+a4b5"};